// Perfil.js
import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";


const Perfil = () => {
  const navigate = useNavigate();

  const nome = global.gNome || "Usuário";
  const email = global.gEmail || "email@dominio.com";
  const tipo = global.gTipoUser || "-";
  const avatarUrl = global.gAvatar || "/default-avatar.png";


  const logout = () => {
    sessionStorage.removeItem("KEY_APP_BGG");
    navigate("/login");
  };

  useEffect(() => {
  const temaSalvo = localStorage.getItem("tema");
  if (temaSalvo === "dark") {
    document.body.classList.add("dark-mode");
  } else {
    document.body.classList.remove("dark-mode");
  }
}, []);


const toggleTema = () => {
  const body = document.body;

  if (body.classList.contains("dark-mode")) {
    body.classList.remove("dark-mode");
    localStorage.setItem("tema", "claro");
  } else {
    body.classList.add("dark-mode");
    localStorage.setItem("tema", "dark");
  }
};


  return (
    <div className="max-w-md mx-auto mt-6 bg-white dark:bg-zinc-900 p-6 rounded shadow">
      <div className="flex items-center gap-4 mb-4">
        <img
          src={avatarUrl}
          alt="avatar"
          className="img-thumbnail shadow"
          style={{ width: "64px", height: "64px", borderRadius: "50%", objectFit: "cover" }}
        />

        <div>
          <h2 className="text-lg font-bold">{nome}</h2>
          <p className="text-sm text-zinc-600 dark:text-zinc-300">{email}</p>
          <p className="text-xs text-zinc-500">Tipo: {tipo}</p>
        </div>
      </div>

      <div className="flex flex-col gap-2 mt-4">
        <button
          onClick={toggleTema}
          className="bg-blue-100 dark:bg-blue-700 text-sm py-2 px-4 rounded shadow text-blue-800 dark:text-white"
        >
          Alternar tema claro/escuro
        </button>
        <button
          onClick={() => navigate("/dashboard")}
          className="bg-secondary text-white text-sm py-2 px-4 rounded shadow"
        >
          Voltar para Início
        </button>


        <button
          onClick={logout}
          className="bg-red-100 dark:bg-red-600 text-sm py-2 px-4 rounded shadow text-red-800 dark:text-white"
        >
          Sair do sistema
        </button>
      </div>
    </div>
  );
};

export default Perfil;